import React, { useEffect, useState } from 'react';
import { FaCheck, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FiLock } from 'react-icons/fi';
import { useModal } from 'src/hooks/Modal';
import { countries } from 'src/utils/countries';
import Input from '../components/Forms/Input';
import MaskedInput from '../components/Forms/MaskedInput';

import SelectSimple from '../components/Forms/SelectSimple';
import { useLanguage } from "../hooks/Language"

import api from '../services/api';
import CheckboxInput from './DashboardPages/core/components/Forms/CheckboxInput';
import states from './SignUp/FormContainer/states';
import { useLoading } from 'src/hooks/LoadingHook';
import { useConfiguration } from 'src/hooks/Configuration';

interface IProps {
    changeCountry: Function;
    countryISO: string;
    checkUserValue?: Function;
    cart?: Record<string, any>[];
    key?: string;
    keyName?: string;
    unique ?: boolean;
}

export const checkDocumentNumber = async (document_number) => {

    const doc = document_number?.toString().replace(/[^0-9]/g, '');
    const valid = await api.get('check-user-document_number', { params: { document_number: doc } });

    return valid?.data?.valid || 'no';

}

const compareProducts = (cart, salesList) => {

    let items : Array<Record<string,any>> = [];

    salesList?.map( i=> {

        const cartItem = cart?.find( product => product?._id?.toString() === i?.product_id);

        if(cartItem){

            items.push(cartItem);
        }


    })


    return items;



}

const DefaultSignUpFormV4: React.FC<IProps> = ({ unique=true, key = 'product', keyName = 'product', checkUserValue = (value) => { }, changeCountry, cart }) => {

    const [countryISO, setCountryISO] = useState('BR')
    const [checkUser, setCheckUser] = useState('')
    const [position, setPosition] = useState('')
    const [currentDocumentNumber, setCurrentDocumentNumber] = useState('');
    const { translate } = useLanguage();
    const [category, setCategory] = useState('');
    const { addModal } = useModal();
    const {configuration} = useConfiguration();

    const {addLoading, removeLoading} = useLoading();

    useEffect(() => {
        setCheckUser('');
        checkUserValue('');
    }, [keyName])



  const checkIfIAmSubscribed = async (document_number) => {
addLoading({title:'Validando...', key:'loading' })
     try {


       const doc = document_number?.toString().replace(/[^0-9]/g, '')
      const listItems: Record<string, any> = [{document_number}, {document_number : doc}];

    
        /* devolver minha lista */

      const response = await api.post('/check-tickets-list', { list: listItems, project_id: configuration?.url })


      if (response?.data?.status === '200') {
        
        removeLoading('loading');
        return true;
      }
      else if (response?.data?.status === '400') {


        const checkCompare = compareProducts(cart, response?.data?.list);



        if(checkCompare?.length > 0){

              addModal({
          theme: 'whiteModalMedium',
          title: '', content: <div className='column full-width'>
            
            
            <p style={{ textAlign: 'center', color: '#333', fontSize: '14px' }}>Prezado participante.
                <br/><br/> 
                Identificamos que você já se inscreveu neste evento.
                    <br/><br/> 
                    <strong style={{ textAlign: 'center', color: '#333', fontSize: '14px' }}>Inscrições já confirmadas:</strong>

               
                </p>

                <div className='column-start full-width'>

                {checkCompare?.map( item => {
                    return      <div style={{width: '100%', padding: '10px', color: '#333', fontSize:'14px'}}>
                        {item?.title}
                    </div>

                })}

                </div>
              <br />
            
          </div>
        })

  removeLoading('loading');
      return false;
        }
        else{

              removeLoading('loading');
        return true;
        }      
      }

    

    }
    catch (err) {


      addModal({
        theme: 'whiteModalMedium',
        title: '', content: <div className='column'>
          <p style={{ textAlign: 'center', color: '#333', fontSize: '14px' }}>{err?.response?.data?.error || err?.response?.data?.message || 'Erro ao validar'}
          </p></div>
      });
      removeLoading('loading');
      return false;


    }



  }


    const verifyAssociate = async (doc, product) => {



        try {

            const validate = await api.get(`/verify-association-api/${product?.hash_link?.toString()}/${product?.project_id}/${doc}`);

            if (validate.status === 200) {
                return true;
            }
            else {
                return false;
            }


        }
        catch (err) {

            addModal({ theme: 'whiteModalMini', title: '', content: <> <p style={{ color: '#333', padding: '10px', fontSize: '14px', textAlign: 'center', width: '100%' }}>{err?.response?.data?.message || err?.response?.data?.error || 'Produto exclusivo para associados'} </p></> })
            return false;
        }



    }


    return <>
        <SelectSimple index={1} setCallback={(value) => setCountryISO(value)} options={countries} name="country" label={translate('Pais')} />


        {countryISO === 'BR' ? <MaskedInput
            mask="999.999.999-99"
            name="document_number"
            setCallback={(value) => setCurrentDocumentNumber(value)}
            placeholder={translate('CPF')}
        /> : <Input setCallback={(value) => setCurrentDocumentNumber(value)} name="document_number"
            placeholder={translate('Nº do documento')} />}

        {!checkUser ? <button type='button' style={{ margin: '5px auto' }} onClick={async () => {

if(unique){
     const check =  checkIfIAmSubscribed(currentDocumentNumber);
     if(!check){
        return;
     }
    }

            const product = cart?.[0];

            if (product?.allowed_only === 'Sim') {
                const checkAssociation = await verifyAssociate(currentDocumentNumber, product);
                if (!checkAssociation) {
                    return;
                }
                else {
                    const check = await checkDocumentNumber(currentDocumentNumber);
                    setCheckUser(check);
                    checkUserValue(check);
                }
            }
            else {

                const check = await checkDocumentNumber(currentDocumentNumber);
                setCheckUser(check);
                checkUserValue(check);

            }



        }} className='greenButton2 buttonColored'>Validar</button> : <></>}
        {checkUser === 'no' ? <>
            {countryISO === 'BR' ? <SelectSimple index={2} options={states} name="state" label="Estado" /> :

                <Input name="state" placeholder={'Província / Região'} />}
            <Input name="city" placeholder={'Município'} />
            <Input name="name" placeholder="Nome completo" />
            <Input name="email" placeholder="E-mail" />

            <Input name="phone" placeholder="Telefone com DDD" />
            <SelectSimple setCallback={(value) => setPosition(value)}
                options={[
                    { value: 'Médico', label: 'Médico' },
                    { value: 'Dentista', label: 'Dentista' },
                    { value: 'Estudante', label: 'Estudante' },
                    { value: 'Profissional da área da saúde', label: 'Profissional da área da saúde' },

                    { value: 'Outro? Qual?', label: 'Outra?' },
                ]}
                name="position"

                label="Profissão"
            />
            {position === 'Médico' && <>


                <SelectSimple
                    options={[

                        { value: 'Anatomia Patológica', label: 'Anatomia Patológica' },
                        { value: 'Anestesiologia', label: 'Anestesiologia' },
                        { value: 'Cardiologia', label: 'Cardiologia' },
                        { value: 'Cirurgia Geral/Especialidade cirúrgica', label: 'Cirurgia Geral/Especialidade cirúrgica' },
                        { value: 'Clínica Médica', label: 'Clínica Médica' },
                        { value: 'Dermatologia', label: 'Dermatologia' },
                        { value: 'Emergencista', label: 'Emergencista' },
                        { value: 'Endocrinologia', label: 'Endocrinologia' },
                        { value: 'Gastroenterologista', label: 'Gastroenterologista' },
                        { value: 'Genética', label: 'Genética' },
                        { value: 'Geriatria', label: 'Geriatria' },
                        { value: 'Gestão/Administração', label: 'Gestão/Administração' },
                        { value: 'Ginecologia', label: 'Ginecologia' },
                        { value: 'Ginecologia e Obstetrícia', label: 'Ginecologia e Obstetrícia' },
                        { value: 'Hematologia', label: 'Hematologia' },
                        { value: 'Infectologia', label: 'Infectologia' },
                        { value: 'Mastologia', label: 'Mastologia' },
                        { value: 'Medicina da Família', label: 'Medicina da Família' },
                        { value: 'Nefrologia', label: 'Nefrologia' },
                        { value: 'Neurologia', label: 'Neurologia' },
                        { value: 'Patologia Clínica', label: 'Patologia Clínica' },
                        { value: 'Radiologia', label: 'Radiologia' },
                        { value: 'Oncologia', label: 'Oncologia' },
                        { value: 'Terapia intensiva', label: 'Terapia intensiva' },
                        { value: 'Urologia', label: 'Urologia' },
                        { value: 'Outras', label: 'Outras' }

                    ]}
                    name="category_id"

                    label="Especialidade"
                /> </>}





            <Input name="company" placeholder={translate('Hospital / Instituição')} />







            <p style={{ fontSize: '14px', textAlign: 'center', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#333' }}> {translate('Crie sua senha de acesso')}</p>



            <Input
                icon={FiLock}
                name="password"
                type="password"
                placeholder={translate('Cadastre sua senha de acesso')}
            />


            <p style={{ fontSize: '14px', textAlign: 'center', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#333' }}> {translate('Privacidade')}</p>


            <SelectSimple index={15}

                options={[
                    { label: 'WhatsApp', value: 'WhatsApp' },
                    { label: 'Indicação', value: 'Indicação' },
                    { label: 'Instagram', value: 'Instagram' },
                    { label: 'Facebook', value: 'Facebook' },
                    { label: 'Linkedin', value: 'Linkedin' },
                    { label: 'E-mail marketing', value: 'E-mail marketing' },
                    { label: 'SMS', value: 'SMS' },
                    { label: 'Workplace', value: 'Workplace' },
                    { label: 'Google', value: 'Google' },
                    { label: 'Outros', value: 'Outros' },
                    { label: 'Site Faculdade 10º CBMH', value: 'Site Faculdade 10º CBMH' },
                    { label: 'Sociedades e associações', value: 'Sociedades e associações' },


                ]}
                name="know_about"

                label="Como soube do evento?"
            />

            <CheckboxInput
                style={{ display: 'flex' }}
                name="term"
                unique={true}
                preText={(
                    <>
                        {' '}
                        Li e aceitos os termos e condições deste evento
                        {' '}

                    </>
                )}
                options={[
                    {
                        id: `Sim, eu aceito`,
                        label: 'Sim, eu aceito',
                        value: `Sim, eu aceito`,
                    },

                ]}
            />


        </> : <></>}




        {checkUser === 'yes' ? <div className='row'><FaCheck style={{ color: 'green', fontSize: '18px', }} /> <p style={{ color: '#333' }}>Usuário identificado</p></div> : <></>}


    </>
}

export default DefaultSignUpFormV4;